import React, {useEffect} from "react"
import {Card, Stack, Typography} from "@mui/joy";
import {SubscriptionPlan} from "../../models/subscription";
import {useAsync} from "../../hooks/useAsyncResult";
import {initPayment} from "../../services/api/transaction";
import {useTranslation} from "react-i18next";


type CheckoutPricingCardComponentProps = {
    selected?: boolean
    subscription?: SubscriptionPlan,
    onSelect?: () => void
}
const CheckoutPricingCardComponent = (props: CheckoutPricingCardComponentProps) => {
    const {t} = useTranslation()
    return <Card size={"lg"} variant={"outlined"}
                 color={props.selected ? "primary" : "neutral"}
                 onClick={props.onSelect}
                 sx={{
                     borderRadius: 15,
                     padding: 1.5,
                     cursor: "pointer",
                     gap: 0,
                     borderWidth: 2,
                     backgroundColor: props.selected ? "primary.softBg" : "transparent"
                 }}>

        <Stack direction={"row"} alignItems={"center"} justifyContent={"space-between"}>
            <Stack>
                <Typography level={"title-lg"}>
                    {props.subscription.isTrial ? t("subscriptionFreeTrialLabel") : props.subscription.name}
                </Typography>

                <Typography level={"body-sm"}>
                    {t("subscriptionDaysLabel", {dayCount: props.subscription.validity})}
                </Typography>
            </Stack>

            {props.subscription.isTrial ?
                <></> :

                <Stack>
                    <Typography level={"title-lg"}>
                        {props.subscription.localizedPrice}
                    </Typography>
                    {!props.subscription.isTrial &&
                        <Typography level={"body-sm"}>
                            {t("subscriptionPaymentTypeLabel")}
                        </Typography>}
                </Stack>}

        </Stack>
    </Card>
}

export default CheckoutPricingCardComponent